import axios from 'axios'
import { genURL } from "../../_getjson";
import { checkData } from '../../_source/checkDatainput'
export default async function Chackprice(code, quantity, arcode, unitcode, taxtype, orderDate, creditcode) {
    let rs = ""
    // console.log("GETPRICEchks", code, QUANTITY, arcode, UNITCODE, TAXTYPE, OrderDate);
    let url = "GETPRICE/GET_CSF_GETARSTDPRICE?" + "DocDate=" + String(orderDate).trim() + "&" + "PRODUCTCODE=" + code + "&QUANTITY=" +
        quantity + "&arcode=" + String(arcode).trim() + "&UNITCODE=" + String(unitcode).trim() + "&TAXTYPE=" + String(taxtype).trim() +
        "&CREDITCODE=" + String(creditcode).trim();

    await axios.get(genURL(url), { timeout: 4800 }).then((res) => {
        console.log("GETPRICE", genURL(url));
        console.log("GETPRICE", res.data[0].UNITPRICE);
        rs = checkData("money", res.data[0].UNITPRICE)
        // this.ReLoadData()
    })
    return rs
};